import "@/assets/styles/table.order.css";

import BasicTable from "@/components/shared/BasicTable";
import { ColDef } from "ag-grid-community";
import { TMSPalletSearchParams, TMSPalletVo } from "@/types/tms";
import classNames from "classnames";
import { PalletsTableRef, useTMSPallets } from "./helper";
import { forwardRef, useImperativeHandle, useRef } from "react";
import { BasicTableRef } from "@/types";

interface PalletsTableProps {
  className?: string;
  cols: ColDef<TMSPalletVo>[];
  query: TMSPalletSearchParams;
  minRowHeight?: number;
  onQueryChange: (query: TMSPalletSearchParams) => void;
}

const TMSPalletsTable = forwardRef<PalletsTableRef, PalletsTableProps>(
  function TMSPalletsTable(props, ref) {
    const { cols, className, query, onQueryChange, minRowHeight = 42 } = props;
    const { data: pallets, refetch, isFetching } = useTMSPallets(query);
    const gridRef = useRef<BasicTableRef>(null);

    useImperativeHandle(
      ref,
      () => ({
        refresh: refetch,
      }),
      [refetch],
    );

    return (
      <BasicTable
        className={classNames("order-table", className)}
        ref={gridRef}
        columns={cols}
        page={pallets}
        loading={isFetching}
        getRowId={(row) => row.no}
        enableRowDetail={false}
        enablePagination={true}
        onRefreshData={refetch}
        onSortChange={(sorts, dirs) => onQueryChange({ sorts, dirs })}
        onPaginationChange={(page, size) => onQueryChange({ size, page })}
        getRowHeight={(params) => {
          let count = params.data?.scannedCartonSkus?.length ?? 0;
          if (count === 0) return minRowHeight;
          count = Math.ceil(count / 2);
          return Math.max(count * 22 + (count - 1) * 4 + 12, minRowHeight);
        }}
      />
    );
  },
);

export default TMSPalletsTable;
